package diana.soleil.design.iraniancanadienbazzar.feature.marketplace

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the Phase-3 peer marketplace. */
val marketplaceModule = module {
    viewModel { MarketplaceViewModel(get(), get(), get(), get(), get(), get(), get(), get()) }
    viewModel { parameters -> MarketplaceItemDetailViewModel(get(), get(), get(), get(), get(), get(), parameters.get()) }
}
